// File: src/components/PaperList.js

import React, { useEffect, useState } from 'react';
import { db } from '../firebase'; // Ensure this path matches your project structure
import { collection, getDocs, doc, updateDoc, increment, query, orderBy } from 'firebase/firestore';
import { useCookies } from 'react-cookie';
import './PaperList.css'; // Ensure this path matches your project structure
import PaperItem from '../components/PaperItem';

const PaperList = () => {
  const [papers, setPapers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [cookies, setCookie] = useCookies(['votedPapers']);
  const [useUCB, setUseUCB] = useState(true);
  const [sortBy, setSortBy] = useState('citations'); // or 'votes', 'citations'
  const [totalViews, setTotalViews] = useState(0);

  useEffect(() => {
    const fetchPapers = async () => {
      try {
        const papersRef = collection(db, 'papers');
        const q = query(papersRef, orderBy('votes', 'desc'));
        const snapshot = await getDocs(q);
        const papersData = snapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data(),
        }));

        const totalViews = papersData.reduce((sum, p) => sum + (p.views || 0), 0) || 1;
        setTotalViews(totalViews);
        let sorted = [...papersData];

        const computeUCB = (paper) => {
          const votes = paper.votes || 0;
          const views = paper.views || 0;
          if (views === 0) return Infinity;
          const avg = votes / views;
          const bonus = Math.sqrt((2 * Math.log(totalViews)) / views);
          return avg + bonus;
        };

        if (sortBy === 'ucb') {
          sorted = sorted.map(p => ({
            ...p,
            ucb: computeUCB(p),
          })).sort((a, b) => b.ucb - a.ucb);
        } else if (sortBy === 'citations') {
          sorted = sorted.sort((a, b) => (b.citations || 0) - (a.citations || 0));
        } else if (sortBy === 'votes') {
          sorted = sorted.sort((a, b) => (b.votes || 0) - (a.votes || 0));
        }
        setPapers(sorted);

      } catch (error) {
        console.error('Error fetching papers:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchPapers();
  }, [sortBy]);

  const handleVote = async (paperId) => {

    const votedPapers = cookies.votedPapers || [];

    if (votedPapers.includes(paperId)) {
        alert('You have already voted for this paper.');
        return;
    }

    try {
      const paperRef = doc(db, 'papers', paperId);
      await updateDoc(paperRef, {
        votes: increment(1),
      });
      // Update local state to reflect the new vote count
      setPapers(prevPapers =>
        prevPapers.map(paper =>
          paper.id === paperId ? { ...paper, votes: (paper.votes || 0) + 1 } : paper
        )
      );

      // Update cookies
      const updatedVotedPapers = [...votedPapers, paperId];
      setCookie('votedPapers', updatedVotedPapers, { path: '/', maxAge: 60 * 60 * 24 * 365 }); // 1 year
    } catch (error) {
      console.error('Error updating vote count:', error);
    }
  };

  if (loading) {
    return <div>Loading papers...</div>;
  }

  return (
    <div className="page-wrapper">
      <h2 className="paper-voter-title">Paper Voter (ICLR 25' Orals)</h2>
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '1rem',
        marginBottom: '1rem',
        flexWrap: 'wrap',
      }}>
        <p style={{ fontStyle: 'italic', margin: 0 }}>
          Currently ranking by: {
            sortBy === 'ucb'
              ? 'UCB Score'
              : sortBy === 'citations'
              ? 'Citations'
              : 'Votes'
          }
        </p>

        <div style={{ display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      gap: '1rem',
                      flexWrap: 'wrap',
                    }}>
          <button onClick={() => setSortBy('citations')}>
            Sort by Citations
          </button>
          <button onClick={() => setSortBy('votes')}>
            Sort by Votes
          </button>
          <button onClick={() => setSortBy('ucb')}>
            UCB Score
          </button>
          
          
        </div>
        

      </div>
      <p style={{ textAlign: 'center', fontWeight: 'bold' }}>
      🔥 Total Views Across All Papers: {totalViews.toLocaleString()} 🔥
      </p>
      
      {/* <p style={{ textAlign: 'center', fontStyle: 'italic' }}>
        Currently ranking by: {useUCB ? 'UCB Score' : 'Votes'}
      </p>
      <button onClick={() => setUseUCB(prev => !prev)} style={{ marginBottom: '1rem' }}>
        {useUCB ? 'Switch to Vote Ranking' : 'Switch to UCB Ranking'}
      </button> */}
      {papers.length === 0 ? (
        <p>No papers found.</p>
      ) : (
        <ul>
        {papers.map(paper => (
          <PaperItem key={paper.id} paper={paper} db={db} handleVote={handleVote} />
        ))}
      </ul>
      )}
    </div>
  );
};

export default PaperList;
